import { Link } from 'react-router-dom';
import { rankingCards } from '../../../../mocks/ranking-cards';

export default function TopCards() {
  // Get top 3 high return rate cards
  const topCards = rankingCards
    .filter(card => {
      const rate = parseFloat(card.returnRate.replace('%', ''));
      return rate >= 1.0;
    })
    .slice(0, 3);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#003366] mb-12">
          高還元率カードTOP3
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {topCards.map((card, index) => (
            <div
              key={card.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow overflow-hidden"
            >
              {/* Rank Badge */}
              <div className="relative">
                <div className={`absolute top-4 left-4 w-16 h-16 flex items-center justify-center rounded-full font-bold text-xl z-10 ${
                  index === 0 ? 'bg-[#FFD700] text-white' :
                  index === 1 ? 'bg-[#C0C0C0] text-white' :
                  'bg-[#CD7F32] text-white'
                }`}>
                  {index + 1}位
                </div>

                {/* Card Image */}
                <div className="w-full h-48 flex items-center justify-center bg-gray-50 p-6">
                  <img
                    src={card.logo}
                    alt={card.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-[#003366] mb-4">
                  <Link to={card.detailUrl} className="hover:text-[#FF9900] hover:underline transition-colors cursor-pointer">
                    {card.name}
                  </Link>
                </h3>

                <div className="space-y-3 mb-6">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">還元率</span>
                    <span className="text-lg font-bold text-[#FF9900]">{card.returnRate}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">年会費</span>
                    <span className="text-lg font-bold text-[#003366]">{card.annualFee}</span>
                  </div>
                </div>

                {/* Benefits */}
                <div className="space-y-2 mb-6">
                  {card.benefits.slice(0, 3).map((benefit, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <i className="ri-check-line text-[#FF9900] text-lg flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                      <p className="text-gray-700 text-sm">{benefit}</p>
                    </div>
                  ))}
                </div>

                {/* CTA Buttons */}
                <div className="space-y-3">
                  <a
                    href={card.officialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-[#FF9900] hover:bg-[#E68A00] text-white font-bold px-6 py-3 rounded-lg transition-all text-center cursor-pointer whitespace-nowrap"
                  >
                    公式サイトを見る
                  </a>
                  <Link
                    to={card.detailUrl}
                    className="block w-full bg-white hover:bg-gray-50 text-[#003366] font-bold px-6 py-3 rounded-lg border-2 border-[#003366] transition-all text-center cursor-pointer whitespace-nowrap"
                  >
                    詳細を見る
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* おすすめカードへのリンク */}
        <div className="mt-12 bg-gradient-to-r from-[#003366] to-[#004488] rounded-2xl p-8 text-white">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold mb-2">高還元率カードをもっと詳しく</h3>
            <p className="text-white/80">各カードの詳細ページで特典や申込方法をチェック</p>
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/rakuten"
              className="inline-flex items-center gap-2 bg-white text-[#003366] font-bold px-6 py-3 rounded-xl hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line"></i>
              大手ECモール系カード詳細
            </Link>
            <Link
              to="/recruit"
              className="inline-flex items-center gap-2 bg-white text-[#003366] font-bold px-6 py-3 rounded-xl hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-percent-line"></i>
              リクルートカード詳細
            </Link>
            <Link
              to="/dcard"
              className="inline-flex items-center gap-2 bg-white text-[#003366] font-bold px-6 py-3 rounded-xl hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-smartphone-line"></i>
              dカード GOLD U詳細
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
